import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class NotificationsComponent {}
